import { ISubscription, SubscriptionType } from "Bands/types";

export const SUBSCRIPTIONS: Record<SubscriptionType, ISubscription> = {
  [SubscriptionType.monthly]: {
    title: "Monthly",
    plan: SubscriptionType.monthly,
    amount: 119,
    billingTerm: "month",
    info: ["Billed monthly", "Billed per band", "Auto-renewed every month"],
  },
  [SubscriptionType.yearly]: {
    title: "Yearly",
    plan: SubscriptionType.yearly,
    amount: 1188,
    billingTerm: "year",
    info: ["Billed yearly", "Billed per band", "Auto-renewed every year"],
  },
  [SubscriptionType.custom]: {
    title: "Custom",
    plan: SubscriptionType.custom,

    info: ["Customizable plan tailored for your needs"],
  },
};
